import axios from 'axios';
import { API_URL } from '../../Config/constant';
import { LayoutContext } from '../../Context/LayoutContext';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../Common/Loader';
import { useState, useContext, useEffect } from 'react';

export default function SearchForm() {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState([{ type: 'searchFormPosition', value: 'over' }]);
  const { apiToken } = useContext(LayoutContext);
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${API_URL}api/settings`,
          {},
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const { result } = response.data;
        if (Array.isArray(result)) {
          const updatedSettings = settings.map((setting) => {
            const fetchedSetting = result.find((item) => item.type === setting.type);
            return fetchedSetting ? { ...setting, value: fetchedSetting.value } : setting;
          });
          // console.log("Settings fetched:", updatedSettings);
          setSettings(updatedSettings);
        } else {
          console.error('Invalid settings data format:', response.data);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      } finally {
        setLoading(false);
      }
    };
    if (apiToken) {
      fetchSettings();
    }
  }, [apiToken]);
  const handlePositionChange = (value) => {
    setSettings((prevSettings) =>
      prevSettings.map((setting) =>
        setting.type === 'searchFormPosition' ? { ...setting, value } : setting
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/cms-settings`, settings, {
        headers: {
          Authorization: `Bearer ${apiToken}`,
          'Content-Type': 'application/json',
        },
      });
      // console.log("Position saved:", response.data);
      toast.success('Position saved successfully!');
    } catch (error) {
      console.error('Error saving position:', error);
      toast.error('Failed to save position.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <Toaster />
      {loading && <Loader />}
      <div className="card-header">
        <h2 className="card-title">Search Form Position</h2>
      </div>
      <div className="form-creation">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xl-3 col-sm-3 col-12">
              <div className="form-group">
                <label>
                  <input
                    type="radio"
                    name="position"
                    value="over"
                    checked={
                      settings.find((s) => s.type === 'searchFormPosition')?.value === 'over'
                    }
                    onChange={(e) => handlePositionChange(e.target.value)}
                  />{' '}
                  Over the hero section
                </label>
              </div>
            </div>
            <div className="col-xl-3 col-sm-3 col-12">
              <div className="form-group">
                <label>
                  <input
                    type="radio"
                    name="position"
                    value="bottom"
                    checked={
                      settings.find((s) => s.type === 'searchFormPosition')?.value === 'bottom'
                    }
                    onChange={(e) => handlePositionChange(e.target.value)}
                  />{' '}
                  Bottom of hero section
                </label>
              </div>
            </div>
            <div className="col-xl-12 col-sm-12 col-12" style={{ textAlign: 'right' }}>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ marginBottom: '10px', padding: '13px' }}
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
